module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"configuration_title":"Konfiguration","save":"Speichern"},"en":{"configuration_title":"Settings","save":"Save"}}')
  delete Component.options._Ctor
}
